import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockColumns from "@/helpers/editor/blocks/CmsBlockColumns.js";
import CmsComponentLink from "@/helpers/editor/components/CmsComponentLink.js";

export default class CmsBlockContainer extends CmsBlock {
    static typeDef = {
        name: `Container|Container`,
        glyph: `fa-square-dashed`,
        type: `container`,
        category: `layout`,
        isParent: true
    }

    get maxChildren() {
        return 20;
    }

    get parentClasses() {
        return [CmsBlockColumns];
    }

    constructor(data, page) {
        super(data, page);

        this.link = new CmsComponentLink(this.link);
        if (!data) {
            this.link.active = false;
        }

        // no-padding flag was removed from all children
        if (page?.isVersionBefore(`1.1.0`)) {
            for (let child of this.children) {
                child.padding.init(0);
            }
        }
    }
}
